import { render, staticRenderFns } from "./SmartMatchProfiles.vue?vue&type=template&id=38ac939a&"
import script from "./SmartMatchProfiles.vue?vue&type=script&lang=js&"
export * from "./SmartMatchProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports